import { render, staticRenderFns } from "./Rirs.vue?vue&type=template&id=17041bed&scoped=true"
import script from "./Rirs.vue?vue&type=script&lang=js"
export * from "./Rirs.vue?vue&type=script&lang=js"
import style0 from "./Rirs.vue?vue&type=style&index=0&id=17041bed&prod&lang=scss&scoped=true"
import style1 from "./Rirs.vue?vue&type=style&index=1&id=17041bed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17041bed",
  null
  
)

export default component.exports